import React, { FC } from 'react';
import SellerPaymentDetails from './SellerPaymentDetails';
import BuyerPaymentDetails from './BuyerPaymentDetails';
import { ReturnDeliveryInfo, ReturnOrderInfo } from '../../../../../typings/returns';

interface ReturnsPaymentDetailsProps {
  isSeller: boolean;
  orderInfo: ReturnOrderInfo;
  deliveryDetails: ReturnDeliveryInfo;
}

const ReturnPaymentDetails: FC<ReturnsPaymentDetailsProps> = ({
  isSeller,
  orderInfo,
  deliveryDetails,
}) => (
  <div data-cy="returns-details-payment-details">
    {isSeller ? (
      <SellerPaymentDetails deliveryDetails={deliveryDetails} />
    ) : (
      <BuyerPaymentDetails orderInfo={orderInfo} />
    )}
  </div>
);

export default ReturnPaymentDetails;
